import { render } from "./ConsultaProdutos.vue?vue&type=template&id=757d2d05&scoped=true&ts=true"
import script from "./ConsultaProdutos.vue?vue&type=script&lang=ts"
export * from "./ConsultaProdutos.vue?vue&type=script&lang=ts"

import "./ConsultaProdutos.vue?vue&type=style&index=0&id=757d2d05&scoped=true&lang=css"

import exportComponent from "D:\\Desenvolvimento\\NeoXApp\\NeoX.Frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-757d2d05"]])

export default __exports__